module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-register-technician-forklift-report/master-register-technician-forklift-report.component.scss
// module id = ./src/app/master/master-register-technician-forklift-report/master-register-technician-forklift-report.component.scss
// module chunks = main